import React from "react";
import SkeletonBlock from "../common/SkeletonBlock";
import ProtocolTaskList from "../tasks/ProtocolTaskList";

function HomeTaskShell() {
  return (
    <section
      aria-hidden="true"
      data-testid="home-task-shell"
      className="w-full flex flex-col gap-2"
    >
      <div className="flex w-full items-start justify-between gap-3 px-1">
        <SkeletonBlock className="h-6 w-40 rounded-full" />
        <SkeletonBlock className="mt-1 h-4 w-16 rounded-full" />
      </div>

      <ProtocolTaskList
        board={{ loading: true }}
        className="!bg-transparent !shadow-none !rounded-none !p-0"
        tasksClassName="gap-1"
        groupedRows
        hideHeader
        emphasizeCounts
      />
    </section>
  );
}

export default function HomePageLoadingShell({ modeOnly = false }) {
  if (modeOnly) {
    return <HomeTaskShell />;
  }

  return (
    <div
      aria-busy="true"
      data-testid="home-page-skeleton"
      className="w-full max-w-lg min-h-full flex flex-col items-center gap-4"
    >
      <div className="w-full flex flex-col items-center gap-4 px-4 md:px-0">
        <HomeTaskShell />
      </div>

      <section className="w-full min-h-fit flex-1 flex flex-col gap-2 bg-greyscale-1 p-4 rounded-t-3xl">
        <SkeletonBlock className="h-6 w-28 rounded-full" />
        <SkeletonBlock className="h-24 w-full rounded-3xl" />
        <div className="grid grid-cols-2 gap-3">
          <SkeletonBlock className="h-32 w-full rounded-3xl" />
          <SkeletonBlock className="h-32 w-full rounded-3xl" />
        </div>
      </section>
    </div>
  );
}
